import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Preview from 'Components/Modals/FileViewer/Preview';
import { useSelectionContextState } from 'Components/UI/ListDetailView/SelectionContext';

const styles = theme => ({
  root: {
    height: `calc(100vh - ${theme.heights.mobileBottomNavigationHeight + theme.heights.mobileNavigationHeight}px)`,
  },
  fileSection: {
    paddingTop: theme.spacing(20),
    width: '100%',
  },
  fileFileContainer: {
    top: theme.spacing(2.5),
  },
  form: {},
  formActions: {},
  formSaveButton: {},
  filePreview: {
    height: '100%',
    border: 'none',
  },
  fileDownload: {
    textAlign: 'center',
    padding: theme.spacing(2),
  },
});

const Detail = ({
  className,
  classes,
}) => {
  const { selectedResource } = useSelectionContextState();

  if (!selectedResource) {
    return null;
  }

  return (
    <div
      className={classNames(classes.root, className)}
    >
      <Preview
        classes={{
          preview: classes.filePreview,
          download: classes.fileDownload,
        }}
        fileName={selectedResource.attr('name')}
        href={selectedResource.relationship(fr.relationships.download.name).link('related').url()}
      />
    </div>
  );
};

Detail.defaultProps = {
  className: '',
};

Detail.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Detail);
